function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getPlatePluginOptions, getPlatePluginType, isElement, getRenderElement } from '@udecode/plate-core';
import { getElementDeserializer, someNode, getParent, getAbove, isCollapsed, findNodePath, ELEMENT_DEFAULT, insertNodes, findNode, setNodes } from '@udecode/plate-common';
import { Editor, Path, Transforms, Node, Point } from 'slate';
var ELEMENT_TABLE = 'table';
var ELEMENT_TH = 'th';
var ELEMENT_TR = 'tr';
var ELEMENT_TD = 'td';
var KEYS_TABLE = [ELEMENT_TABLE, ELEMENT_TH, ELEMENT_TR, ELEMENT_TD];
var DEFAULTS_TH = {
  getNodeProps: function getNodeProps(_ref) {
    var element = _ref.element;
    var _element$attributes, _element$attributes2;
    return {
      colSpan: element === null || element === void 0 ? void 0 : (_element$attributes = element.attributes) === null || _element$attributes === void 0 ? void 0 : _element$attributes.colspan,
      rowSpan: element === null || element === void 0 ? void 0 : (_element$attributes2 = element.attributes) === null || _element$attributes2 === void 0 ? void 0 : _element$attributes2.rowspan
    };
  }
};
var DEFAULTS_TD = {
  getNodeProps: function getNodeProps(_ref2) {
    var element = _ref2.element;
    var _element$attributes3, _element$attributes4;
    return {
      colSpan: element === null || element === void 0 ? void 0 : (_element$attributes3 = element.attributes) === null || _element$attributes3 === void 0 ? void 0 : _element$attributes3.colspan,
      rowSpan: element === null || element === void 0 ? void 0 : (_element$attributes4 = element.attributes) === null || _element$attributes4 === void 0 ? void 0 : _element$attributes4.rowspan
    };
  }
};
var getTableDeserialize = function getTableDeserialize() {
  return function (editor) {
    var table = getPlatePluginOptions(editor, ELEMENT_TABLE);
    var td = getPlatePluginOptions(editor, ELEMENT_TD);
    var th = getPlatePluginOptions(editor, ELEMENT_TH);
    var tr = getPlatePluginOptions(editor, ELEMENT_TR);
    return {
      element: [].concat(_toConsumableArray(getElementDeserializer(_objectSpread({
        type: table.type,
        rules: [{
          nodeNames: 'TABLE'
        }]
      }, table.deserialize))), _toConsumableArray(getElementDeserializer(_objectSpread({
        type: tr.type,
        rules: [{
          nodeNames: 'TR'
        }]
      }, tr.deserialize))), _toConsumableArray(getElementDeserializer(_objectSpread({
        type: td.type,
        attributeNames: ['rowspan', 'colspan'],
        rules: [{
          nodeNames: 'TD'
        }]
      }, td.deserialize))), _toConsumableArray(getElementDeserializer(_objectSpread({
        type: th.type,
        attributeNames: ['rowspan', 'colspan'],
        rules: [{
          nodeNames: 'TH'
        }]
      }, th.deserialize))))
    };
  };
};
function getCellInNextTableRow(editor, currentRowPath) {
  try {
    var _nextRowNode$children;
    var nextRow = Editor.node(editor, Path.next(currentRowPath)); // TODO: Many tables in rich text editors (Google Docs, Word),
    // add a new row if we're in the last cell. Should we do the same?

    var _nextRow = _slicedToArray(nextRow, 2),
      nextRowNode = _nextRow[0],
      nextRowPath = _nextRow[1];
    var nextCell = nextRowNode === null || nextRowNode === void 0 ? void 0 : (_nextRowNode$children = nextRowNode.children) === null || _nextRowNode$children === void 0 ? void 0 : _nextRowNode$children[0];
    var nextCellPath = nextRowPath.concat(0);
    if (nextCell && nextCellPath) {
      return Editor.node(editor, nextCellPath);
    }
  } catch (err) {}
}
function getNextTableCell(editor, currentCell, currentPath, currentRow) {
  try {
    return Editor.node(editor, Path.next(currentPath));
  } catch (err) {
    var _currentRow = _slicedToArray(currentRow, 2),
      currentRowPath = _currentRow[1];
    return getCellInNextTableRow(editor, currentRowPath);
  }
}
function getCellInPreviousTableRow(editor, currentRowPath) {
  try {
    var _previousRowNode$chil;
    var previousRow = Editor.node(editor, Path.previous(currentRowPath));
    var _previousRow = _slicedToArray(previousRow, 2),
      previousRowNode = _previousRow[0],
      previousRowPath = _previousRow[1];
    var previousCell = previousRowNode === null || previousRowNode === void 0 ? void 0 : (_previousRowNode$chil = previousRowNode.children) === null || _previousRowNode$chil === void 0 ? void 0 : _previousRowNode$chil[previousRowNode.children.length - 1];
    var previousCellPath = previousRowPath.concat(previousRowNode.children.length - 1);
    if (previousCell && previousCellPath) {
      return Editor.node(editor, previousCellPath);
    }
  } catch (err) {}
}
function getPreviousTableCell(editor, currentCell, currentPath, currentRow) {
  try {
    return Editor.node(editor, Path.previous(currentPath));
  } catch (err) {
    var _currentRow2 = _slicedToArray(currentRow, 2),
      currentRowPath = _currentRow2[1];
    return getCellInPreviousTableRow(editor, currentRowPath);
  }
}

/**
 * If at (default = selection) is in table>tr>td or table>tr>th,
 * return table, tr, and td or th node entries.
 */

var getTableCellEntry = function getTableCellEntry(editor) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$at = _ref3.at,
    at = _ref3$at === void 0 ? editor.selection : _ref3$at;
  if (at && someNode(editor, {
    at: at,
    match: {
      type: [getPlatePluginType(editor, ELEMENT_TD), getPlatePluginType(editor, ELEMENT_TH)]
    }
  })) {
    var selectionParent = getParent(editor, at);
    if (!selectionParent) return;
    var _selectionParent = _slicedToArray(selectionParent, 2),
      paragraphPath = _selectionParent[1];
    var tableCell = getAbove(editor, {
      at: at,
      match: {
        type: [getPlatePluginType(editor, ELEMENT_TD), getPlatePluginType(editor, ELEMENT_TH)]
      }
    }) || getParent(editor, paragraphPath);
    if (!tableCell) return;
    var _tableCell = _slicedToArray(tableCell, 2),
      tableCellNode = _tableCell[0],
      tableCellPath = _tableCell[1];
    if (tableCellNode.type !== getPlatePluginType(editor, ELEMENT_TD) && tableCellNode.type !== getPlatePluginType(editor, ELEMENT_TH)) return;
    var tableRow = getParent(editor, tableCellPath);
    if (!tableRow) return;
    var _tableRow = _slicedToArray(tableRow, 2),
      tableRowNode = _tableRow[0],
      tableRowPath = _tableRow[1];
    if (tableRowNode.type !== getPlatePluginType(editor, ELEMENT_TR)) return;
    var tableElement = getParent(editor, tableRowPath);
    if (!tableElement) return;
    return {
      tableElement: tableElement,
      tableRow: tableRow,
      tableCell: tableCell
    };
  }
};
var getTableOnKeyDown = function getTableOnKeyDown() {
  return function (editor) {
    return function (e) {
      if (e.key === 'Tab') {
        e.preventDefault();
        var res = getTableCellEntry(editor, {});
        if (!res) return;
        var tableRow = res.tableRow,
          tableCell = res.tableCell;
        var _tableCell2 = _slicedToArray(tableCell, 2),
          tableCellPath = _tableCell2[1];
        var shiftTab = e.shiftKey;
        var tab = !e.shiftKey;
        if (shiftTab) {
          // move left with shift+tab
          var previousCell = getPreviousTableCell(editor, tableCell, tableCellPath, tableRow);
          if (previousCell) {
            var _previousCell = _slicedToArray(previousCell, 2),
              previousCellPath = _previousCell[1];
            Transforms.select(editor, previousCellPath);
          }
        } else if (tab) {
          // move right with tab
          var nextCell = getNextTableCell(editor, tableCell, tableCellPath, tableRow);
          if (nextCell) {
            var _nextCell = _slicedToArray(nextCell, 2),
              nextCellPath = _nextCell[1];
            Transforms.select(editor, nextCellPath);
          }
        }
      } // FIXME: would prefer this as mod+a, but doesn't work

      if (e.key === 'a' && (e.metaKey || e.ctrlKey)) {
        var options = getPlatePluginOptions(editor, ELEMENT_TABLE);
        var _res = getAbove(editor, {
          match: {
            type: options.type
          }
        });
        if (!_res) return;
        var _res2 = _slicedToArray(_res, 2),
          tablePath = _res2[1]; // select the whole table

        Transforms.select(editor, tablePath);
        e.preventDefault();
        e.stopPropagation();
      }
    };
  };
};
var withTable = function withTable() {
  return function (editor) {
    var matchCells = function matchCells(node) {
      return isElement(node) && (node.type === getPlatePluginType(editor, ELEMENT_TD) || node.type === getPlatePluginType(editor, ELEMENT_TH));
    };
    var deleteBackward = editor.deleteBackward,
      deleteForward = editor.deleteForward,
      deleteFragment = editor.deleteFragment,
      insertText = editor.insertText;
    var preventDeleteCell = function preventDeleteCell(operation, pointCallback, nextPoint) {
      return function (unit) {
        var selection = editor.selection;
        if (isCollapsed(selection)) {
          var _Editor$nodes = Editor.nodes(editor, {
              match: matchCells
            }),
            _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
            cell = _Editor$nodes2[0];
          if (cell) {
            // Prevent deletions within a cell
            var _cell = _slicedToArray(cell, 2),
              cellPath = _cell[1];
            var start = pointCallback(editor, cellPath);
            if (selection && Point.equals(selection.anchor, start)) {
              return;
            }
          } else {
            // Prevent deleting cell when selection is before or after a table
            var next = nextPoint(editor, selection, {
              unit: unit
            });
            var _Editor$nodes3 = Editor.nodes(editor, {
                match: matchCells,
                at: next
              }),
              _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
              nextCell = _Editor$nodes4[0];
            if (nextCell) return;
          }
        }
        operation(unit);
      };
    };
    editor.deleteFragment = function () {
      var selection = editor.selection;
      var _Editor$nodes5 = Editor.nodes(editor, {
          match: matchCells,
          at: selection === null || selection === void 0 ? void 0 : selection.anchor.path
        }),
        _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
        start = _Editor$nodes6[0];
      var _Editor$nodes7 = Editor.nodes(editor, {
          match: matchCells,
          at: selection === null || selection === void 0 ? void 0 : selection.focus.path
        }),
        _Editor$nodes8 = _slicedToArray(_Editor$nodes7, 1),
        end = _Editor$nodes8[0]; // Skip deletes if they start or end in a table cell, unless start & end in the same cell

      if ((start || end) && (start === null || start === void 0 ? void 0 : start[0]) !== (end === null || end === void 0 ? void 0 : end[0])) {
        // Clear cells content
        var cells = Editor.nodes(editor, {
          match: matchCells
        });
        var _iterator = _createForOfIteratorHelper(cells),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              path = _step$value[1];
            var _iterator2 = _createForOfIteratorHelper(Node.children(editor, path, {
                reverse: true
              })),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                  childPath = _step2$value[1];
                Transforms.removeNodes(editor, {
                  at: childPath
                });
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        Transforms.collapse(editor);
        return;
      }
      deleteFragment();
    };
    editor.insertText = function (text) {
      var selection = editor.selection;
      var _Editor$nodes9 = Editor.nodes(editor, {
          match: matchCells,
          at: selection === null || selection === void 0 ? void 0 : selection.anchor.path
        }),
        _Editor$nodes10 = _slicedToArray(_Editor$nodes9, 1),
        start = _Editor$nodes10[0];
      var _Editor$nodes11 = Editor.nodes(editor, {
          match: matchCells,
          at: selection === null || selection === void 0 ? void 0 : selection.focus.path
        }),
        _Editor$nodes12 = _slicedToArray(_Editor$nodes11, 1),
        end = _Editor$nodes12[0]; // Collapse selection if multiple cells are selected to avoid breaking the table

      if (!isCollapsed(selection) && (start || end) && (start === null || start === void 0 ? void 0 : start[0]) !== (end === null || end === void 0 ? void 0 : end[0])) {
        var _Editor$nodes13 = Editor.nodes(editor, {
            match: matchCells
          }),
          _Editor$nodes14 = _slicedToArray(_Editor$nodes13, 1),
          cell = _Editor$nodes14[0];
        if (cell) {
          Transforms.collapse(editor, {
            edge: 'end'
          });
          insertText(text);
          return;
        }
      }
      insertText(text);
    }; // prevent deleting cells with deleteBackward

    editor.deleteBackward = preventDeleteCell(deleteBackward, Editor.start, Editor.before); // prevent deleting cells with deleteForward

    editor.deleteForward = preventDeleteCell(deleteForward, Editor.end, Editor.after);
    return editor;
  };
};

/**
 * Enables support for tables.
 */

var createTablePlugin = function createTablePlugin() {
  return {
    pluginKeys: KEYS_TABLE,
    renderElement: getRenderElement(KEYS_TABLE),
    deserialize: getTableDeserialize(),
    onKeyDown: getTableOnKeyDown(),
    withOverrides: withTable()
  };
};
var getTableColumnCount = function getTableColumnCount(tableNode) {
  var _tableNode$children$, _tableNode$children$2;
  return (_tableNode$children$ = (_tableNode$children$2 = tableNode.children[0]) === null || _tableNode$children$2 === void 0 ? void 0 : _tableNode$children$2.children.length) !== null && _tableNode$children$ !== void 0 ? _tableNode$children$ : 0;
};

/**
 * Get table column index of a cell node.
 */
var getTableColumnIndex = function getTableColumnIndex(editor, _ref4) {
  var node = _ref4.node;
  var _getParent;
  var path = findNodePath(editor, node);
  if (!path) return 0;
  var _ref5 = (_getParent = getParent(editor, path)) !== null && _getParent !== void 0 ? _getParent : [],
    _ref6 = _slicedToArray(_ref5, 1),
    trNode = _ref6[0];
  if (!trNode) return 0;
  var colIndex = 0;
  trNode.children.some(function (item, index) {
    if (item === node) {
      colIndex = index;
      return true;
    }
    return false;
  });
  return colIndex;
};
var getEmptyCellNode = function getEmptyCellNode(editor, _ref7) {
  var header = _ref7.header;
  return {
    type: header ? getPlatePluginType(editor, ELEMENT_TH) : getPlatePluginType(editor, ELEMENT_TD),
    children: [{
      type: getPlatePluginType(editor, ELEMENT_DEFAULT),
      children: [{
        text: ''
      }]
    }]
  };
};
var addColumn = function addColumn(editor, _ref8) {
  var header = _ref8.header;
  if (someNode(editor, {
    match: {
      type: getPlatePluginType(editor, ELEMENT_TABLE)
    }
  })) {
    var currentCellItem = getAbove(editor, {
      match: {
        type: [getPlatePluginType(editor, ELEMENT_TH), getPlatePluginType(editor, ELEMENT_TD)]
      }
    });
    var currentTableItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TABLE)
      }
    });
    if (currentCellItem && currentTableItem) {
      var nextCellPath = Path.next(currentCellItem[1]);
      var newCellPath = nextCellPath.slice();
      var replacePathPos = newCellPath.length - 2;
      var currentRowIdx = nextCellPath[replacePathPos];
      currentTableItem[0].children.forEach(function (row, rowIdx) {
        newCellPath[replacePathPos] = rowIdx;
        var isHeaderRow = header === undefined ? row.children[0].type === ELEMENT_TH : header;
        insertNodes(editor, getEmptyCellNode(editor, {
          header: isHeaderRow
        }), {
          at: newCellPath,
          select: rowIdx === currentRowIdx
        });
      });
    }
  }
};
var getEmptyRowNode = function getEmptyRowNode(editor, _ref9) {
  var header = _ref9.header,
    colCount = _ref9.colCount;
  return {
    type: getPlatePluginType(editor, ELEMENT_TR),
    children: Array(colCount).fill(colCount).map(function () {
      return getEmptyCellNode(editor, {
        header: header
      });
    })
  };
};
var addRow = function addRow(editor, _ref10) {
  var header = _ref10.header;
  if (someNode(editor, {
    match: {
      type: getPlatePluginType(editor, ELEMENT_TABLE)
    }
  })) {
    var currentRowItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TR)
      }
    });
    if (currentRowItem) {
      var _currentRowItem = _slicedToArray(currentRowItem, 2),
        currentRowElem = _currentRowItem[0],
        currentRowPath = _currentRowItem[1];
      insertNodes(editor, getEmptyRowNode(editor, {
        header: header,
        colCount: currentRowElem.children.length
      }), {
        at: Path.next(currentRowPath),
        select: true
      });
    }
  }
};
var deleteColumn = function deleteColumn(editor) {
  if (someNode(editor, {
    match: {
      type: getPlatePluginType(editor, ELEMENT_TABLE)
    }
  })) {
    var currentCellItem = getAbove(editor, {
      match: {
        type: [getPlatePluginType(editor, ELEMENT_TD), getPlatePluginType(editor, ELEMENT_TH)]
      }
    });
    var currentRowItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TR)
      }
    });
    var currentTableItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TABLE)
      }
    });
    if (currentCellItem && currentRowItem && currentTableItem &&
    // Cannot delete the last cell
    currentRowItem[0].children.length > 1) {
      var currentCellPath = currentCellItem[1];
      var pathToDelete = currentCellPath.slice();
      var replacePathPos = pathToDelete.length - 2;
      currentTableItem[0].children.forEach(function (row, rowIdx) {
        pathToDelete[replacePathPos] = rowIdx;
        Transforms.removeNodes(editor, {
          at: pathToDelete
        });
      });
    }
  }
};
var deleteRow = function deleteRow(editor) {
  if (someNode(editor, {
    match: {
      type: getPlatePluginType(editor, ELEMENT_TABLE)
    }
  })) {
    var currentTableItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TABLE)
      }
    });
    var currentRowItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TR)
      }
    });
    if (currentRowItem && currentTableItem &&
    // Cannot delete the last row
    currentTableItem[0].children.length > 1) {
      Transforms.removeNodes(editor, {
        at: currentRowItem[1]
      });
    }
  }
};
var deleteTable = function deleteTable(editor) {
  if (someNode(editor, {
    match: {
      type: getPlatePluginType(editor, ELEMENT_TABLE)
    }
  })) {
    var tableItem = getAbove(editor, {
      match: {
        type: getPlatePluginType(editor, ELEMENT_TABLE)
      }
    });
    if (tableItem) {
      Transforms.removeNodes(editor, {
        at: tableItem[1]
      });
    }
  }
};
var getEmptyTableNode = function getEmptyTableNode(editor, _ref11) {
  var header = _ref11.header;
  return {
    type: getPlatePluginType(editor, ELEMENT_TABLE),
    children: [getEmptyRowNode(editor, {
      header: header,
      colCount: 2
    }), getEmptyRowNode(editor, {
      header: false,
      colCount: 2
    })]
  };
};
var insertTable = function insertTable(editor, _ref12) {
  var header = _ref12.header;
  if (!someNode(editor, {
    match: {
      type: getPlatePluginType(editor, ELEMENT_TABLE)
    }
  })) {
    insertNodes(editor, getEmptyTableNode(editor, {
      header: header
    }));
  }
};
var setTableColSize = function setTableColSize(editor, _ref13) {
  var colIndex = _ref13.colIndex,
    width = _ref13.width;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var table = findNode(editor, _objectSpread(_objectSpread({}, options), {}, {
    match: {
      type: ELEMENT_TABLE
    }
  }));
  if (!table) return;
  var _table = _slicedToArray(table, 2),
    tableNode = _table[0],
    tablePath = _table[1];
  var colSizes = tableNode.colSizes ? _toConsumableArray(tableNode.colSizes) : Array(getTableColumnCount(tableNode)).fill(0);
  colSizes[colIndex] = width;
  setNodes(editor, {
    colSizes: colSizes
  }, {
    at: tablePath
  });
};
export { DEFAULTS_TD, DEFAULTS_TH, ELEMENT_TABLE, ELEMENT_TD, ELEMENT_TH, ELEMENT_TR, KEYS_TABLE, addColumn, addRow, createTablePlugin, deleteColumn, deleteRow, deleteTable, getCellInNextTableRow, getCellInPreviousTableRow, getEmptyCellNode, getEmptyRowNode, getEmptyTableNode, getNextTableCell, getPreviousTableCell, getTableCellEntry, getTableColumnCount, getTableColumnIndex, getTableDeserialize, getTableOnKeyDown, insertTable, setTableColSize, withTable };